export default defineAppConfig({
  ui: {
    colors: {
      primary: 'indigo',
      secondary: 'blue',
      neutral: 'gray',
      success: 'green',
      info: 'blue',
      warning: 'yellow',
      error: 'red',
    },
    inputMenu: {
      slots: {
        base: 'w-full',
        tagsInput: 'w-full',
      },
    },
    tabs: {
      compoundVariants: [
        {
          orientation: 'horizontal',
          variant: 'link',
          class: {
            list: 'border-b -mb-px',
            indicator: 'bottom-0 h-[2px]',
          },
        },
      ],
    },
    // collapsible: {
    //   slots: {
    //     root: `
    //       [&>button]:bg-elevated [&>button]:text-default [&>button]:hover:bg-accented [&>button]:data-[state=closed]:rounded-b-lg
    //       [&>button]:rounded-b-none [&>button]:rounded-t-lg [&>button]:transition-[border-radius] [&>button]:duration-200 [&>button]:font-bold
    //     `,
    //   },
    // },
    badge: {
      slots: {
        base: '!rounded-full !text-sm !px-2.5 !py-0',
      },
      variants: {
        color: {
          primary: '!text-white',
          secondary: '!text-white',
        },
      },
    },
    button: {
      slots: {
        base: 'cursor-pointer rounded-lg flex disabled:cursor-not-allowed text-default',
        leadingIcon: 'shrink-0',
      },
      variants: {
        size: {
          sm: {
            base: '!text-button-sm px-2.5 py-1.5',
            leadingIcon: 'h-3 w-3',
            trailingIcon: 'h-3 w-3',
          },
          md: {
            base: '!text-button px-3 py-2',
            leadingIcon: 'h-3.5 w-3.5',
            trailingIcon: 'h-3.5 w-3.5',
          },
          lg: {
            base: '!text-lg px-4 py-3',
            leadingIcon: 'h-5 w-5',
            trailingIcon: 'h-5 w-5',
          },
        },
        variant: {
          link: '!text-secondary-600 !hover:text-secondary-800 hover:underline',
          outline: '!bg-white disabled:bg-white disabled:ring-neutral-400 disabled:text-neutral-400',
          solid: '!text-white !disabled:bg-gray-300',
        },
      },
      defaultVariants: {
        color: 'secondary',
        size: 'md',
        variant: 'solid',
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'bg-primary-600 hover:bg-primary-800',
        },
        {
          color: 'primary',
          variant: 'outline',
          class:
            'text-primary-600 ring-primary-600 hover:bg-primary-50 hover:ring-primary-800 hover:text-primary-800',
        },
        {
          color: 'secondary',
          variant: 'solid',
          class: 'bg-secondary-600 hover:bg-secondary-800',
        },
        {
          color: 'secondary',
          variant: 'outline',
          class:
            'text-secondary-600 ring-secondary-600 hover:bg-secondary-50 hover:ring-secondary-800 hover:text-secondary-800',
        },
        {
          color: 'success',
          variant: 'solid',
          class: 'bg-success-600 hover:bg-success-800',
        },
        {
          color: 'success',
          variant: 'outline',
          class:
            'text-success-600 ring-success-600 hover:bg-success-50 hover:ring-success-800 hover:text-success-800',
        },
        {
          color: 'warning',
          variant: 'solid',
          class: 'bg-warning-500 hover:bg-warning-700',
        },
        {
          color: 'warning',
          variant: 'outline',
          class:
            'text-warning-500 ring-warning-500 hover:bg-warning-50 hover:ring-warning-700 hover:text-warning-700',
        },
        {
          color: 'error',
          variant: 'solid',
          class: 'bg-error-600 hover:bg-error-800',
        },
        {
          color: 'error',
          variant: 'outline',
          class:
            'text-error-600 ring-error-600 hover:bg-error-50 hover:ring-error-800 hover:text-error-800',
        },
        {
          color: 'info',
          variant: 'solid',
          class: 'bg-info-600 hover:bg-info-800',
        },
        {
          color: 'info',
          variant: 'outline',
          class:
            'text-info-600 ring-info-600 hover:bg-info-50 hover:ring-info-800 hover:text-info-800',
        },
        {
          color: 'neutral',
          variant: 'solid',
          class: 'bg-neutral-600 hover:bg-neutral-800',
        },
        {
          color: 'neutral',
          variant: 'outline',
          class:
            'text-neutral-600 ring-neutral-600 hover:bg-neutral-50 hover:ring-neutral-800 hover:text-neutral-800',
        },
        {
          variant: 'link',
          size: 'md',
          class: 'text-link',
        },
        {
          variant: 'link',
          size: 'sm',
          class: 'text-link-sm',
        },
      ],
    },
    switch: {
      slots: {
        base: 'data-[state=unchecked]:bg-neutral-200',
        thumb: 'bg-white border border-neutral-300',
      },
      defaultVariants: {
        color: 'secondary',
      },
    },
  },
})
